import { ILead } from "../models/Lead";

const normalise = (vrm: string | null | undefined) => (vrm ?? "").replace(/\s/g, "").toUpperCase();

/**
 * The reg the seller typed, when it differs from the vehicle's current plate - e.g. they quoted
 * FA16MUE and the lookup found the car under its private plate X99OLL. Superchat and the call
 * centre use the typed one, so it needs to be visible next to the plate. Null when they match.
 */
export function enteredRegIfDifferent(lead: Pick<ILead, "vehicleRegistration" | "vehicle"> | null | undefined) {
  const entered = normalise(lead?.vehicleRegistration);
  const current = normalise(lead?.vehicle?.vrm);

  return entered && current && entered !== current ? entered : null;
}
